import { Table, Space, Tag, Typography, Tooltip, Empty } from "antd";

const { Text, Paragraph } = Typography;

const yesNo = (v) => (v === true ? "Yes" : v === false ? "No" : "-");
const pad = (n) => String(n).padStart(2, "0");
const fmtClaimDate = (c) => {
  const { claim_year: y, claim_month: m, claim_day: d } = c ?? {};
  if (!y && !m && !d) return "";
  return `${y ?? "----"}-${m ? pad(m) : "--"}-${d ? pad(d) : "--"}`;
};
const fmtClaimAmount = (n) => {
  if (n === null || n === undefined || n === "") return "";
  const num = Number(n);
  if (Number.isNaN(num)) return "";
  return num.toLocaleString("en-CA", { style: "currency", currency: "CAD" });
};
const nfmt = (n) => {
  if (n === null || n === undefined || n === "") return "-";
  const num = Number(n);
  if (Number.isNaN(num)) return "-";
  return num.toLocaleString("en-CA");
};
const pilotName = (p, idx) => {
  const name = `${p?.pilot_first_name ?? ""} ${
    p?.pilot_last_name ?? ""
  }`.trim();
  return name || `Pilot ${idx + 1}`;
};

const PilotInformationDetails = ({ data }) => {
  const pilots = Array.isArray(data?.pilots) ? data.pilots : [];

  if (!pilots.length) {
    return <Empty description="No pilots added" />;
  }

  const columns = [
    {
      title: "Pilot",
      key: "pilot",
      width: 220,
      render: (_, record, idx) => <Text strong>{pilotName(record, idx)}</Text>,
      fixed: "left",
    },
    {
      title: "Licenses/Ratings",
      key: "license_ratings",
      render: (_, r) =>
        Array.isArray(r.license_ratings) && r.license_ratings.length ? (
          <Space wrap>
            {r.license_ratings.map((x, i) => (
              <Tag key={`${x}-${i}`}>{x}</Tag>
            ))}
          </Space>
        ) : (
          "-"
        ),
    },
    {
      title: "Total (All)",
      dataIndex: "total_all_aircraft",
      key: "total_all_aircraft",
      width: 120,
      align: "right",
      render: nfmt,
    },
    {
      title: "Total (M&M)",
      dataIndex: "total_make_model",
      key: "total_make_model",
      width: 120,
      align: "right",
      render: nfmt,
    },
    {
      title: "Accidents/Claims (5y)",
      key: "accidents",
      width: 200,
      render: (_, r) => {
        const ans = yesNo(r.has_had_accidents);
        const claims = Array.isArray(r.accidents_claim_amount)
          ? r.accidents_claim_amount
          : [];
        if (!r.has_had_accidents || claims.length === 0) return ans;
        return (
          <Tooltip
            title={
              <div>
                {claims.map((c, i) => (
                  <div key={i}>
                    {[
                      fmtClaimDate(c),
                      fmtClaimAmount(c?.claim_amount),
                      c?.claim_description,
                    ]
                      .filter(Boolean)
                      .join(" — ")}
                  </div>
                ))}
              </div>
            }
          >
            <span>
              {ans} • {claims.length} claim{claims.length > 1 ? "s" : ""}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Notes",
      dataIndex: "notes_and_comments",
      key: "notes_and_comments",
      width: 320,
      render: (v) =>
        v ? (
          <Tooltip title={v}>
            <Paragraph
              style={{ margin: 0 }}
              ellipsis={{ rows: 1, tooltip: false }}
            >
              {v}
            </Paragraph>
          </Tooltip>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <Table
      size="small"
      bordered
      pagination={false}
      scroll={{ x: 980 }}
      columns={columns}
      dataSource={pilots.map((p, i) => ({ ...p, key: i }))}
    />
  );
};

export default PilotInformationDetails;
